export default __webpack_public_path__ + "static/media/home_carousel_0@2x.02101b78.png";